module.exports = __webpack_public_path__ + "img/CLS-P-170.52e071d3.svg";